export const GET_SESSION = 'GET_SESSION';
export const GET_SESSION_CHECK = 'GET_SESSION_CHECK';
export const DELETE_SESSION = 'GET_SESSION';
export const SESSION_LOADING = 'SESSION_LOADING';
export const SESSION_FETCHING = 'SESSION_FETCHING';
